<template>
  <div class="garantie-view">
    <template v-if="isBusy">
      <Preloader />
    </template>
    <template v-else>
      <div class="garantie-view__head">
        <div
          class="garantie-view__head--icon"
          @click="$router.push('/devis')"
          v-if="showRetourButton"
        >
          <font-awesome-icon prefix="fas" icon="arrow-circle-left" />
          Retour
        </div>
      </div>
      <div class="garantie-view__head">
        <div class="garantie-view__head--title">Devis en ligne</div>
      </div>
      <div class="garantie-view__body">
        <div class="garantie-view__body__block">
          <div class="garantie-view__body__block--title">
            RAPPEL DES INFORMATIONS COMMUNIQUÉES
          </div>
          <div
            class="garantie-view__body__block--content"
            v-if="insurance.client"
          >
            <div class="title">Vos coordonnées :</div>
            <div class="row">
              <template
                v-if="+insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID"
              >
                <div class="col-12">
                  <div class="field">
                    <div class="field__label">Civilité :</div>
                    <div class="field__value">
                      {{ parseCivility(insurance.client.civility) }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-12">
                  <div class="field">
                    <div class="field__label">Société:</div>
                    <div class="field__value">
                      {{ insurance.client.name_of_signatory }}
                    </div>
                  </div>
                </div>
              </template>

              <template
                v-if="+insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID"
              >
                <div class="col-12 col-md-6">
                  <div class="field">
                    <div class="field__label">Nom :</div>
                    <div class="field__value">
                      {{ insurance.client.last_name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6" v-if="insurance.client.first_name">
                  <div class="field">
                    <div class="field__label">Prénom :</div>
                    <div class="field__value">
                      {{ insurance.client.first_name }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-12 col-md-6">
                  <div class="field">
                    <div class="field__label">Nom du signataire :</div>
                    <div class="field__value">
                      {{ insurance.client.last_name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6" v-if="insurance.client.first_name">
                  <div class="field">
                    <div class="field__label">Prénom du signataire :</div>
                    <div class="field__value">
                      {{ insurance.client.first_name }}
                    </div>
                  </div>
                </div>
              </template>
              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Adresse :</div>
                  <div class="field__value">{{ insurance.client.address }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Code postal :</div>
                  <div class="field__value">{{ insurance.client.zip }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Ville :</div>
                  <div class="field__value">{{ insurance.client.city }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Téléphone :</div>
                  <div class="field__value">{{ insurance.client.tel }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Email :</div>
                  <div class="field__value">{{ insurance.client.email }}</div>
                </div>
              </div>

              <div class="col-12 col-md-6" v-if="insurance.client && insurance.client.birthday && insurance.client.birthday != '1900-01-01 00:00:00'">
                <div class="field">
                  <div class="field__label">Date de naissance :</div>
                  <div class="field__value">{{ parseBirthDate(insurance.client.birthday) }}</div>
                </div>
              </div>

              <!--<div class="col-12 col-md-6" v-if="insurance.details">-->
              <!--<div class="field">-->
              <!--<div class="field__label">Date de permis:</div>-->
              <!--<div class="field__value">-->
              <!--{{moment(insurance.details.date_allowed).format('DD/MM/Y')}}-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
            </div>
          </div>
          <!--<div class="divider"></div>-->

          <!--DETAILS-->

          <div
            class="garantie-view__body__block--content"
            v-if="insurance.details"
          >
            <div class="title">Votre Véhicule :</div>

            <div class="row">
              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Garantie :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseValue(insurance.details.garantie, INSURANCE_AUTO) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4"><b>Durée :</b></div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseValue(insurance.details.duration, AUTO_DURATION) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Type de véhicule :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseValue(insurance.details.type_vehicle, AUTO_TYPE) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Marque/Modèle :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.car_brand }} /
                    {{ insurance.details.modele_porteur }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Carburant :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseValue(insurance.details.car_fuel, AUTO_ENGINE) }}
                  </div>
                </div>
              </div>

              <div
                class="col-12"
                v-if="+insurance.details.car_fuel !== AUTO_ENGINE.ELECTRIC.ID"
              >
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Cylindrée :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseTypeCylinder(insurance.details.cylinder) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Puissance fiscale :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.fiscal_power }}
                  </div>
                </div>
              </div>

              <div
                class="col-12"
                v-if="+insurance.details.car_fuel === AUTO_ENGINE.ELECTRIC.ID"
              >
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Puissance en Kw :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseValue(insurance.details.power_kw, AUTO_POWER_KW) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Immatriculation :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.registration }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Date de 1ère mise en circulation :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseCirculationDate(insurance.details) }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Numéro de série :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ insurance.details.serial_number }}
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Kilométrage :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{
                      insurance.details.km_real
                        ? insurance.details.km_real
                        : "-"
                    }}
                  </div>
                </div>
              </div>

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Km compteur :</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">-->
              <!--{{insurance.details.km_counter ? insurance.details.km_counter : '-'}}-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Km au jour de la jour :</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">{{insurance.details.km_day}}</div>-->
              <!--</div>-->
              <!--</div>-->

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Appellation commerciale :</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">{{insurance.details.app_commercial}}</div>-->
              <!--</div>-->
              <!--</div>-->

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Km au jour de la vente :</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">{{insurance.details.km_day}}</div>-->
              <!--</div>-->
              <!--</div>-->

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Numéro d'immatriculation précédent-->
              <!--:</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">-->
              <!--{{insurance.details.registration_old_number ? insurance.details.registration_old_number : '-'}}-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Date de la livraison :</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">{{parseDeliveryDate(insurance.details)}}-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->

              <!--<div class="col-12">-->
              <!--<div class="field">-->
              <!--<div class="field__label col-12 col-sm-4"><b>Date de vente :</b></div>-->
              <!--<div class="field__value col-12 col-sm-8">{{parseSaleDate(insurance.details)}}</div>-->
              <!--</div>-->
              <!--</div>-->

              <div class="col-12">
                <div class="field">
                  <div class="field__label col-12 col-sm-4">
                    <b>Date d'effet :</b>
                  </div>
                  <div class="field__value col-12 col-sm-8">
                    {{ parseEffectiveDate(insurance.details) }}
                  </div>
                </div>
              </div>

              <!--                            <div class="col-12">-->
              <!--                                <div class="field">-->
              <!--                                    <div class="field__label col-12 col-sm-4"><b>Assistance :</b></div>-->
              <!--                                    <div class="field__value col-12 col-sm-8">{{parseAssistance(insurance.details)}}-->
              <!--                                    </div>-->
              <!--                                </div>-->
              <!--                            </div>-->
            </div>
          </div>

          <div
            class="garantie-view__body__block--warning"
            v-if="numberOfDuplicates > 0"
          >
            Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro
            d’immatriculation.
          </div>

          <div class="garantie-view__body__block--link">
            <router-link :to="/garantie-autos/ + $route.params.id"
              >Cliquer ici pour modifier vos coordonnées
            </router-link>
          </div>

          <div class="garantie-view__body__block mt-3">
            <div class="garantie-view__body__block--title">
              Vous avez choisi la panne m&eacute;canique
              {{ parseValue(insurance.details.garantie, INSURANCE_AUTO) }} pour
              une dur&eacute;e de
              {{ parseValue(insurance.details.duration, AUTO_DURATION) }}
            </div>

            <div class="garantie-view__body__block--content">
              <div class="description">
                <div class="label mb-2 rem-18">
                  <div class="label--bold">Dur&eacute;e et prise d'effet</div>
                </div>

                <div
                  class="font-weight-bold rem-14"
                  v-if="mechanicCode != '705223'"
                >
                  Sous r&eacute;serve du paiement de la prime et de
                  l'acceptation de la garantie par
                  <strong>Dynassurances</strong>, la garantie s'applique suivant
                  la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                  particuli&egrave;res du contrat et prendra fin automatiquement
                  &agrave; 24 heures jour pour jour selon les dates
                  indiqu&eacute;es sur le certificat de garantie.
                  <br />
                  Cependant la garantie prendra fin de plein droit avant son
                  terme :
                </div>
                <div class="font-weight-bold rem-14" v-else>
                  Sous r&eacute;serve du paiement de la prime et de
                  l'acceptation de la garantie, la garantie s'applique suivant
                  la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                  particuli&egrave;res du contrat et prendra fin automatiquement
                  &agrave; 24 heures jour pour jour selon les dates
                  indiqu&eacute;es sur le certificat de garantie.
                  <br />
                  Cependant la garantie prendra fin de plein droit avant son
                  terme :
                </div>

                <div class="list mt-3">
                  <ul class="list__ul">
                    <li>
                      en cas de destruction du v&eacute;hicule, quelle qu'en
                      soit la cause, par r&eacute;siliation,
                    </li>
                    <li>
                      en cas de d&eacute;ch&eacute;ance du
                      b&eacute;n&eacute;ficiaire de la garantie pour non respect
                      des prescriptions du constructeur sur l'usage pour lequel
                      le v&eacute;hicule est con&ccedil;u.
                    </li>
                  </ul>
                </div>
                <div class="price-block">
                  <div class="divider mt-4 mb-4"></div>

                  <div class="row mt-3">
                    <div class="col-12 col-md-6">
                      <div class="label">
                        <div class="label--bold">
                          Prime annuelle T.T.C. (&euro;) *
                        </div>
                      </div>
                    </div>

                    <template v-if="getPrice">
                      <div class="col-12 col-md-6">
                        <div class="label">
                          <div class="label--bold">
                            {{ getPrice }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-12 col-md-6">
                        <div class="label">
                          <div
                            class="label--red"
                            v-if="mechanicCode != '705223'"
                          >
                            Les critères du véhicule ne permettent pas de
                            souscrire à la garantie choisie.<br />
                            Pour effectuer une demande de dérogation, veuillez
                            adresser le contrôle technique à l’adresse
                            <a href="mailto:servicetechnique@dynassurances.fr"
                              >servicetechnique@dynassurances.fr</a
                            >
                            avec les informations suivantes :
                            <ul>
                              <li>Immatriculation du véhicule</li>
                              <li>Votre code garage</li>
                            </ul>
                          </div>
                          <div class="label--red" v-else>
                            Les critères du véhicule ne permettent pas de
                            souscrire à la garantie choisie.<br />
                            Pour effectuer une demande de dérogation, veuillez
                            adresser le contrôle technique avec les informations
                            suivantes :
                            <ul>
                              <li>Immatriculation du véhicule</li>
                              <li>Votre code garage</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div
                    class="row mt-3"
                    v-if="insurance && insurance.assistance_price > 0"
                  >
                    <div class="col-12 col-md-6">
                      <div class="label">
                        <div class="label--bold">Dont assitance</div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div class="label">
                        <div class="label--bold">
                          {{
                            roundEURWithoutSymbol(
                              insurance.assistance_price
                            ).replace(".", ",")
                          }}
                          €
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="agenda mt-3">
                    <div class="agenda--small">
                      * Frais de dossier et taxe attentats inclus
                    </div>
                  </div>
                  <div class="mt-3">
                    Pour nous contacter ou souscrire : 01 48 89 57 57
                  </div>

                  <div class="divider mt-3 mb-3"></div>
                </div>
                <div class="insurance-info">
                  <div class="insurance-info__buttons row">
                    <div
                      class="col-6 text-right insurance-info__buttons--wrapper"
                    >
                      <a href="#" @click.prenevt="printInsurance()" class="blue"
                        >Imprimer le détail de la garantie</a
                      >
                      <div class="ball-anchor blue"></div>
                    </div>
                    <div
                      class="col-6 text-right insurance-info__buttons--wrapper"
                      v-if="mechanicCode != '705223'"
                    >
                      <a href="#" @click.prenevt="getFrontPdf()" class="green"
                        >Sauvegarder sur mon ordinateur</a
                      >
                      <div class="ball-anchor green"></div>
                    </div>
                    <div
                      class="col-6 text-right insurance-info__buttons--wrapper"
                      v-else
                    >
                      <a href="#" @click.prenevt="getFrontPdfWL()" class="green"
                        >Sauvegarder sur mon ordinateur</a
                      >
                      <div class="ball-anchor green"></div>
                    </div>
                    <div class="col-6 insurance-info__buttons--wrapper">
                      <template v-if="isBusyResend">
                        <Preloader />
                      </template>
                      <template v-else>
                        <!--                                                <a href="#" @click.prevent="resendEmail()" class="green">Recevoir le-->
                        <!--                                                    devis par e-mail</a>-->
                        <!--                                                <div class="ball-anchor green"></div>-->
                        &nbsp;
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="printManyPages">
              <div class="print-page-break"></div>
            </template>

            <div
              class="garantie-view__body__block--title"
              :class="{ 'new-page-padding': printManyPages }"
            >
              Garanties accordées
            </div>

            <div class="garantie-view__body__block--content">
              <div class="description">
                <div class="list mt-3">
                  <!--&#45;&#45;-->
                  <!--<ul class="list__ul">-->
                  <!--<li><b>Moteur :</b>-->
                  <!--<div>-->
                  <!--L'arbre &agrave; cames, les coussinets de t&ecirc;te de bielle, les-->
                  <!--bielles,-->
                  <!--les culbuteurs et tiges de culbuteurs, les poussoirs, les engrenages et-->
                  <!--chaîne-->
                  <!--de distribution, les paliers de vilebrequin, le vilbrequin, les pistons-->
                  <!--et axes-->
                  <!--de piston, les segments, les soupapes et guides de soupapes, la pompe-->
                  <!--&agrave;-->
                  <!--huile, la culasse, le joint de culasse et le turbo.-->
                  <!--</div>-->
                  <!--</li>-->
                  <!--<li><b>Boîte de vitesse manuelle ou automatique / Boîte de transfert :</b>-->
                  <!--<div>-->
                  <!--Toutes les pi&egrave;ces composantes y compris l'arbre moteur et le-->
                  <!--convertisseur &agrave; l'exclusion des commandes externes.-->
                  <!--</div>-->
                  <!--</li>-->
                  <!--<li><b>Dispositif de transmission :</b>-->
                  <!--<div>-->
                  <!--L'arbre de transmission longitudinal, les arbres secondaires, les diff&eacute;rentiels,-->
                  <!--les pignons et les couronnes y compris le pont arri&egrave;re.-->
                  <!--</div>-->
                  <!--</li>-->
                  <!--<template v-if="insurance.details && insurance.details.type_vehicle !== 1"> &lt;!&ndash; display this p only if not V.P as insurance type &ndash;&gt;-->
                  <!--<li><b>Pour les 4 x 4 et les v&eacute;hicules utilitaires :</b>-->
                  <!--<div>-->
                  <!--La garantie est limit&eacute;e au moteur - boîte(s) - pont(s). Ils ne-->
                  <!--sont-->
                  <!--pas garantis : la culasse, le joint de culasse et le turbo.-->
                  <!--</div>-->
                  <!--</li>-->
                  <!--</template>-->
                  <!--</ul>-->
                  <Accordes :insurance="insurance" />
                  <!-- -&#45;&#45;-->
                </div>

                <!--<div class="insurance-info">-->
                <!--<div class="insurance-info__buttons">-->
                <!--<div class="insurance-info__buttons__item insurance-info__buttons__item&#45;&#45;33">-->
                <!--<div class="insurance-info__buttons&#45;&#45;wrapper">-->
                <!--<a href="#" @click.prevent="getConfirmationPDF()" class="purple">Confirmation de garantie</a>-->
                <!--<div class="ball-anchor purple"></div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->

                <div class="insurance-info">
                  <div class="insurance-info__buttons">
                    <div
                      class="insurance-info__buttons__item insurance-info__buttons__item--33"
                    >
                      <div class="insurance-info__buttons--wrapper">
                        <router-link
                          :to="/garantie-autos/ + $route.params.id"
                          class="blue"
                        >
                          Modifier
                        </router-link>
                        <div class="ball-anchor blue"></div>
                      </div>
                    </div>
                    <!--                                        <div class="insurance-info__buttons__item insurance-info__buttons__item&#45;&#45;33" v-if="getGarantiePrice">-->
                    <!--                                            <div class="insurance-info__buttons&#45;&#45;wrapper" v-if="mechanicCode != '705223'">-->
                    <!--                                                <a href="#" @click.prevent="checkSubscription(insurance, getPDF)" class="purple">Souscrire à la garantie</a>-->
                    <!--                                                <div class="ball-anchor purple"></div>-->
                    <!--                                            </div>-->
                    <!--                                          <div class="insurance-info__buttons&#45;&#45;wrapper" v-else>-->
                    <!--                                            <a href="#" @click.prevent="checkSubscription(insurance, getPDFWL)" class="purple">Souscrire à la garantie</a>-->
                    <!--                                            <div class="ball-anchor purple"></div>-->
                    <!--                                          </div>-->
                    <!--                                        </div>-->
                    <div
                      class="insurance-info__buttons__item insurance-info__buttons__item--33"
                      v-if="
                        this.$store.getters.isSarrut ||
                        this.$store.getters.isSarrutAdmin
                      "
                    >
                      <!-- <div class="col-6 text-right insurance-info__buttons--wrapper">
                                          <a href="#" @click.prenevt="checkSubscription(insurance, resendEmail)" class="green">Envoyer devis par email</a>
                                          <div class="ball-anchor green"></div>
                                        </div> -->
                      <div
                        class="col-6 text-right insurance-info__buttons--wrapper"
                        v-if="getPrice"
                      >
                        <a
                          href="#"
                          @click.prevent="
                            checkSubscription(insurance, resendEmail)
                          "
                          class="green"
                          >Envoyer devis par email</a
                        >
                        <div class="ball-anchor green"></div>
                      </div>
                      <div
                        class="col-6 text-right insurance-info__buttons--wrapper"
                        v-else
                      >
                        <a
                          href="#"
                          @click.prevent="confirmSubscription"
                          class="green"
                          >Envoyer devis par email</a
                        >
                        <div class="ball-anchor green"></div>
                      </div>
                    </div>
                    <div
                      class="insurance-info__buttons__item insurance-info__buttons__item--33"
                    >
                      <div class="insurance-info__buttons--wrapper">
                        <router-link
                          v-if="!showRetourButton"
                          :to="'/'"
                          class="black"
                          >Fermer</router-link
                        >
                        <router-link v-else :to="'/devis'" class="black"
                          >Fermer</router-link
                        >
                        <div class="ball-anchor black"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PdfModal
        v-show="pdfModal"
        @close="closePdfModal"
        :quote="this.insurance"
        :is-shown="pdfModal"
      />
    </template>
  </div>
</template>

<script>
import PdfModal from "@/components/Garantie/PdfModal";
import Preloader from "@/components/Preloader";
import garantieFieldsList from "../../mixins/garantieFieldsLists";
import Accordes from "./GarantiesAccordesAuto";
import {
  AUTO_DURATION,
  AUTO_ENGINE,
  AUTO_POWER_KW,
  AUTO_TYPE,
  INSURANCE_AUTO,
} from "../../constants/insuranceAuto";
import insuranceMethods from "../../mixins/insuranceMethods";
import { CLIENT_CIVILITY } from "../../constants/client";

export default {
  name: "GarantieAutosView",
  components: {
    PdfModal,
    Preloader,
    Accordes,
  },
  mixins: [garantieFieldsList, insuranceMethods],
  data() {
    return {
      isBusy: false,
      isBusyResend: false,
      pdfModal: false,
      insurance: {
        address: null,
        category: null,
        city: null,
        civility: null,
        email: null,
        first_name: null,
        last_name: null,
        tel: null,
        zip: null,
      },
      showRetourButton: false,
      AUTO_ENGINE,
      AUTO_POWER_KW,
      AUTO_TYPE,
      INSURANCE_AUTO,
      AUTO_DURATION,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
    };
  },
  computed: {
    printManyPages() {
      return (
        this.insurance &&
        this.insurance.details &&
        +this.insurance.details.garantie != 3
      );
    },
    getDownloadLinkConfirmationPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/confirmation-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLink() {
      if (this.insurance.id) {
        // alert('getDownloadLink 592');
        return this.getApiAuthUrl(
          "garantie/generate-sarrut-pdf/" + this.insurance.id
        );
        // alert('after getDownloadLink 594');
      }

      return "";
    },
    getDownloadLinkWL() {
      if (this.insurance.id) {
        // alert('getDownloadLink 592');
        return this.getApiAuthUrl(
          "garantie/generate-pdfWL/" + this.insurance.id
        );
        // alert('after getDownloadLink 594');
      }

      return "";
    },
    getDownloadLinkCopyPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkCopyPdfWL() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdfWL/" + this.insurance.id
        );

      return "";
    },
    getPrice() {
      return this.insurance.price
        ? this.roundEURWithoutSymbol(this.insurance.price).replace(".", ",") +
            " €"
        : "";
    },
    getGarantiePrice() {
      console.log("getGarantiePrice");
      console.log(this.insurance);
      return this.insurance.price && +this.insurance.price > 0;
    },
    mechanicCode() {
      let code =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.code
          : null;
      return code ? code : "";
    },
  },
  methods: {
    confirmSubscription() {
      this.$confirm({
        message:
          "Les critères du véhicule ne permettent pas de souscrire à la garantie choisie. Etes-vous sûr de vouloir envoyer un devis sans prix à votre client ?",
        button: {
          no: "Non",
          yes: "Oui"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.checkSubscription(this.insurance, this.resendEmail)
          }
        }
      });
    },
    getConfirmationPDF() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkConfirmationPdf) {
            window.location = this.getDownloadLinkConfirmationPdf;
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    closePdfModal() {
      this.pdfModal = false;
    },
    getPDF() {
      // alert('getPDF');
      if (this.checkEffectiveDate(this.insurance)) {
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLink) {
              // alert('getDownloadLink 631');
              let pdfWindow = window.open(this.getDownloadLink);
              if (pdfWindow) this.pdfWindow = pdfWindow;
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getPDFWL() {
      // alert('getPDF');
      if (this.checkEffectiveDate(this.insurance)) {
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLink) {
              // alert('getDownloadLink 631');
              let pdfWindow = window.open(this.getDownloadLinkWL);
              if (pdfWindow) this.pdfWindow = pdfWindow;
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    printInsurance() {
      window.print();
    },
    resendEmail() {
      this.isBusyResend = true;
      let url = "garantie/send-email/sarrut/" + this.insurance.id;

      this.apiPost(url, {})
        .then((response) => {
          this.isBusyResend = false;
          if (response.data.quote && response.data.status == "success") {
            this.showSuccessNotification(response.data.message, "");
          }
        })
        .catch((error) => {
          this.isBusyResend = false;
          this.showErrorNotification(error);
        });
    },
    getQuoteInfo() {
      this.isBusy = true;
      let url = "garantie/" + this.$route.params.id;
      this.apiGet(url)
        .then((response) => {
          this.insurance = response.data.quote;
          this.numberOfDuplicates = response.data.duplicates;
          this.isBusy = false;
        })
        .catch((error) => {
          this.showErrorNotification(error);
          this.$router.push("/");
        });
    },
    parseValue(
      parsed_value,
      available_options,
      field_id = "ID",
      field_name = "NAME"
    ) {
      for (let value in available_options) {
        if (available_options[value][field_id] === +parsed_value)
          return available_options[value][field_name];
      }
      return "";
    },
    parseTypeCylinder(vehicle) {
      return this.list_type_cylinder[vehicle]
        ? this.list_type_cylinder[vehicle]
        : "";
    },
    parseCivility(civility) {
      switch (+civility) {
        case 0:
          return "M";
        case 1:
          return "Mlle";
        case 2:
          return "Mme";
        case 3:
          return "Société";
        default:
          return "";
      }
    },
    parseCarBrand(brand) {
      return this.list_marque_auto[brand] ? this.list_marque_auto[brand] : "";
    },
    parseCirculationDate(details) {
      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? (day = "0" + day.toString()) : "";
      month.length < 2 ? (month = "0" + month.toString()) : "";

      let date = this.moment(new Date()).date(day).month(month).year(year);
      return date.format("DD/MM/YYYY");
    },
    parseSaleDate(quoteDatails) {
      if (quoteDatails.sale_date) {
        return this.moment(quoteDatails.sale_date).format("DD/MM/Y");
      }

      return "";
    },
    parseEffectiveDate(quoteDatails) {
      if (quoteDatails.effective_date) {
        return this.moment(quoteDatails.effective_date).format("DD/MM/Y");
      }

      return "";
    },
    parseBirthDate(birthdate) {
      if (birthdate) {
        return this.moment(birthdate).format("DD/MM/Y");
      }

      return "";
    },
    parseDeliveryDate(quoteDatails) {
      if (quoteDatails.delivery_date) {
        return this.moment(quoteDatails.delivery_date).format("DD/MM/Y");
      }

      return "";
    },
    parseAssistance(quoteDatails) {
      return +quoteDatails.assistance === 1 ? "Oui" : "Non";
    },
    parseCylinder(cylinder) {
      return this.list_cylinders_moto[cylinder]
        ? this.list_cylinders_moto[cylinder]
        : "";
    },
    getFrontPdf() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdf) {
            window.open(this.getDownloadLinkCopyPdf);
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    getFrontPdfWL() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdfWL) {
            window.open(this.getDownloadLinkCopyPdfWL);
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
  },
  created() {
    this.getQuoteInfo();
  },
  mounted() {
    this.$eventBus.$emit("sidebar-set-active-tab", "Garantie Auto");

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch("backToDevisDisable");
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit("sidebar-set-active-tab", "");
  },
  watch: {
    pdfWindow: function () {
      window.location.href = "/merci";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieAutosView.vue